import {
  BaseApplicationService,
  reportUnexpectedError,
} from "@graffer-inc/smart-apply";
import {
  ApplicationTask,
  ApplicationTaskDetail,
} from "../../../domain/application/application-task";
import { gqlClient, gqlHeader, runGqlQueryV2 } from "@graffer-inc/smart-apply";

export type ApplicationTaskContextProps = {
  isLoading: boolean;
  task?: ApplicationTask;
  onLoad: typeof ApplicationTaskService.prototype.onLoad;
};

export class ApplicationTaskService extends BaseApplicationService<ApplicationTaskContextProps> {
  state = {
    isLoading: false,
    task: undefined,
    onLoad: this.onLoad.bind(this),
  };

  async onLoad(id: string) {
    this.setState({ isLoading: true });
    try {
      const res = await runGqlQueryV2(() =>
        gqlClient.applicationTaskAndUser({ id: id }, gqlHeader("q")),
      );
      if (res.error) {
        reportUnexpectedError(res.error.rawError);
      }
      if (res.data) {
        const rawData = res.data.applicationTaskAndUser;
        const task: ApplicationTask = {
          id: rawData.id,
          orgId: rawData.orgId,
          taskType: rawData.taskType,
          taskDetails: rawData.taskDetails.map(
            (d) => d as ApplicationTaskDetail,
          ),
          userName: rawData.user.name,
          createdAt: rawData.createdAt,
          updatedAt: rawData.updatedAt,
        };
        this.setState({
          task: task,
        });
      }
    } catch (e) {
      reportUnexpectedError(e);
    } finally {
      this.setState({ isLoading: false });
    }
  }
}
